<template>
    <div class="animated fadeIn">
      <table class="table">
        <thead>
        <tr>
          <td>Listing Name</td>
          <td>Status</td>
          <td></td>
        </tr>
        </thead>
        <tbody>
        <subscription-item
          v-for="subscription in subscriptions"
          :key="subscription.id"
          v-bind:subscription="subscription"
        ></subscription-item>
        </tbody>
      </table>
    </div>
</template>
<script>
  import SubscriptionItem from "./SubscriptionItem";
  export default {
      name: 'subscription-table',
      components: {
          SubscriptionItem,
      },
      props: {
            subscriptions: {},
      },
  }
</script>

<style>
  thead td {
    font-weight: bold;
  }
</style>
